import React, { useCallback, useEffect } from 'react';
import get from 'lodash/get';
import { useForm, useLoadSection } from '~/hooks';
import { stringUtils } from '~/util';
const { hasValue } = stringUtils;
import sectionTypes from '../sectionTypes';
import { ValidationErrorMessage } from '..';

const initialState = {
    sectionId: 0,
    hasErrors: false,
    taxYear: '',
    endorsements: [],
    donorPolicyRecipient: '',
    lenderPolicyRecipient: '',
    attorneyCopyRecipient: '',
    additionalInfo: ''
};

const Review = ({ titleOpinionId, handleValidation }) => {
    const { onLoad: loadSection } = useLoadSection(sectionTypes.ADDITIONAL, titleOpinionId);

    const onLoad = useCallback(async (values) => {
        const sectionValues = await loadSection(values);

        const taxYear = get(sectionValues, 'taxYear', '');
        const endorsements = get(sectionValues, 'endorsements', []).map(e => e.label);

        return {
            ...sectionValues,
            taxYear,
            endorsements,
            hasErrors: !hasValue(taxYear)
        };
    }, [loadSection]);

    const {  state: { values } } = useForm({ initialState, onLoad });

    const formattedEndorsements = Array.isArray(values.endorsements)
        ? values.endorsements.reduce((s, e) => s.length ? `${s}, ${e}` : e, '')
        : '';

    useEffect(async () => {
        await handleValidation(values.hasErrors);
    }, [values]);

    return (
        <div className='text-xs text-neutral-90 py-4 flex flex-col'>
            { values.hasErrors && (
                <ValidationErrorMessage className='self-stretch mb-2' />
            )}
            <div className='flex items-center'>
                <p className='font-semibold text-neutral-100 mr-6'>Taxes are paid through and including</p>
                <p>{values.taxYear}</p>
            </div>
            <div className='flex items-center my-2'>
                <p className='font-semibold text-neutral-100 mr-6'>Requested ALTA Endorsements</p>
                <p>{formattedEndorsements}</p>
            </div>
            <div className='flex flex-col my-4'>
                <p className='font-semibold text-neutral-100'>For any corporate entity involved in this transaction, the certifying attorney certifies as follows:</p>
                <p className='font-semibold italic text-neutral-100 mt-1'>The undersigned counsel certifies that all companies involved in this transaction were in good standing and authorized to do business in the State of North Carolina and the person signing the closing documents was authorized to do so at the time of closing.</p>
            </div>
            <div className='flex items-start my-2'>
                <p className='font-semibold text-neutral-100 w-1/6'>Send Owner’s Title Policy To</p>
                <pre className='font-sans'>{values.ownerPolicyRecipient}</pre>
            </div>
            <div className='flex items-start my-2'>
                <p className='font-semibold text-neutral-100 w-1/6'>Send Lender’s Title Policy To</p>
                <pre className='font-sans'>{values.lenderPolicyRecipient}</pre>
            </div>
            <div className='flex items-start my-2'>
                <p className='font-semibold text-neutral-100 w-1/6'>Send Attorney’s Copies To</p>
                <pre className='font-sans'>{values.attorneyCopyRecipient}</pre>
            </div>
            <div className='flex items-start my-2'>
                <p className='font-semibold text-neutral-100 mr-6'>Additional Information</p>
                <pre className='font-sans'>{values.additionalInfo}</pre>
            </div>
            <div className='flex items-center my-2'>
                <p className='font-semibold text-neutral-100 mr-6'>Additional Documents</p>
                {(values?.documents || []).map(document => document?.name || '').join(', ')}
            </div>
        </div>
    );
};

export default Review;